import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ApiService,
  GET_ADMIN_USERS_PATH,
  GET_ADMIN_USERS_STATS_PATH,
  GetAdminUsersResponse,
  GetAdminUsersStatsQueryParams,
  GetAdminUsersStatsResponse,
  SET_USER_MODERATION_FLAG_PATH,
  SetUserModerationFlagBody,
  SetUserModerationFlagPathParams
} from '@core-http';

export class UsersListService extends ApiService {
  getUsers(search?: string): Observable<GetAdminUsersResponse> {
    const params: string = search ? `?search=${encodeURIComponent(search)}` : '';
    return this.httpClient.get<GetAdminUsersResponse>(`${this.env.apiUrl}${GET_ADMIN_USERS_PATH}${params}`);
  }

  setModerationFlag(pathParams: SetUserModerationFlagPathParams, payload: SetUserModerationFlagBody): Observable<void> {
    const path: string = this.fillPathParams(SET_USER_MODERATION_FLAG_PATH, pathParams);

    return this.httpClient.patch<void>(`${this.env.apiUrl}${path}`, payload);
  }

  getUsersStats(queryParams: GetAdminUsersStatsQueryParams = {}): Observable<GetAdminUsersStatsResponse> {
    const params: HttpParams = this.fillQueryParams(queryParams);
    return this.httpClient.get<GetAdminUsersStatsResponse>(`${this.env.apiUrl}${GET_ADMIN_USERS_STATS_PATH}`, {
      params
    });
  }
}
